import React, { createContext, useContext, useState, useCallback } from 'react';
import { fetchTransaction } from '../api/transaction';

const TransactionContext = createContext(null);

export const TransactionProvider = ({ children }) => {
  const [transaction, setTransaction] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const loadTransaction = useCallback(async (id) => {
    setLoading(true);
    setError(null);
    setTransaction(null);
    try {
      const data = await fetchTransaction(id);
      setTransaction(data);
    } catch (err) {
      setError(err.message ?? 'Failed to load transaction');
    } finally {
      setLoading(false);
    }
  }, []);

  return (
    <TransactionContext.Provider value={{ transaction, loading, error, loadTransaction }}>
      {children}
    </TransactionContext.Provider>
  );
};

export const useTransactionStore = () => {
  const ctx = useContext(TransactionContext);
  if (!ctx) throw new Error('useTransactionStore must be used inside TransactionProvider');
  return ctx;
};
